// Canonical list of investor types supported by the onboarding workflow.
// Each required field and document in a fund's onboarding workflow may be scoped
// to one or more of these types via the `applicable_investor_types` array.
// An empty array (or missing key) means "applies to ALL investor types".

export const INVESTOR_TYPES = [
  "Individual",
  "Corporate",
  "Partnership",
  "Trust",
  "Non-Profit",
];

/**
 * Returns the list of investor types this item applies to, supporting the
 * legacy `applicable_entity_types` key for backward compatibility.
 */
export function getApplicableTypes(item) {
  if (!item) return [];
  const primary = Array.isArray(item.applicable_investor_types) ? item.applicable_investor_types : null;
  if (primary && primary.length) return primary;
  const legacy = Array.isArray(item.applicable_entity_types) ? item.applicable_entity_types : null;
  if (legacy && legacy.length) return legacy;
  return [];
}

/**
 * Keep only items that apply to the given investor type. When `investorType`
 * is empty, every item is returned (pre-selection state). When an item has no
 * applicable types configured, it is treated as universal and always kept.
 */
export function filterByInvestorType(items, investorType) {
  if (!Array.isArray(items)) return [];
  if (!investorType) return items;
  return items.filter((item) => {
    const types = getApplicableTypes(item);
    if (types.length === 0) return true; // universal
    return types.includes(investorType);
  });
}
